module.exports = __webpack_public_path__ + "img/heating-de.5abf0fb7.png";